export const irrelevantWords = [
  // English words
  "who",
  "why",
  "what",
  "when",
  "how",
  "where",
  "is",
  "are",
  "the",
  "then",
  "was",
  "were",
  "a",
  "an",
  "i",
  "you",
  "it",
  "he",
  "she",
  "we",
  "they",
  "this",
  "that",
  "there",
  "their",
  "of",
  "to",
  "for",
  "with",
  "and",
  "but",
  "or",
  "so",
  "as",
  "by",
  "on",
  "at",
  "from",
  "up",
  "down",
  "into",
  "out",
  "than",
  "not",
  "be",
  "being",
  "been",
  "has",
  "have",
  "had",
  "having",
  "do",
  "does",
  "did",
  "doing",
  "a",
  "an",
  "the",
  "in",
  "and",
  "for",
  "on",
  "off",
  "above",
  "below",
  "between",
  "into",
  "through",
  "across",
  "after",
  "before",
  "during",
  "over",
  "under",
  "around",
  "along",
  "alongside",
  "within",
  "without",
  "against",
  "among",
  "throughout",
  "during",
  "until",
  "while",
  "as",
  "just",
  "like",
  "such",
  "only",
  "all",
  "any",
  "both",
  "each",
  "few",
  "more",
  "most",
  "several",
  "some",
  "same",
  "either",
  "neither",
  "another",
  "one",
  "two",
  "three",
  "first",
  "second",
  "next",
  "last",
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "ten",
  "eleven",
  "twelve",
  "thirteen",
  "fourteen",
  "fifteen",
  "sixteen",
  "seventeen",
  "eighteen",
  "nineteen",
  "twenty",
  "any",
  "no",
  "yes",
  "nor",
  "not",
  "because",
  "since",
  "while",
  "if",
  "though",
  "although",
  "whether",
  "after",
  "before",
  "until",
  "unless",
  "during",
  "on",
  "at",
  "by",
  "to",
  "with",
  "for",
  "against",
  "about",
  "among",
  "between",
  "during",
  "into",
  "around",
  "off",
  "from",
  "in",
  "into",
  "along",
  "upon",
  "across",

  // Malay counterparts
  "siapa",
  "kenapa",
  "apa",
  "bila",
  "bagaimana",
  "di mana",
  "adalah",
  "ialah",
  "yang",
  "itu",
  "adalah",
  "adalah",
  "satu",
  "seorang",
  "saya",
  "anda",
  "ia",
  "dia",
  "kami",
  "mereka",
  "ini",
  "itu",
  "di sana",
  "mereka",
  "daripada",
  "kepada",
  "untuk",
  "dengan",
  "dan",
  "tetapi",
  "atau",
  "jadi",
  "sebagai",
  "oleh",
  "di",
  "pada",
  "daripada",
  "atas",
  "ke bawah",
  "ke dalam",
  "keluar",
  "daripada",
  "tidak",
  "menjadi",
  "sedang",
  "telah",
  "ada",
  "mempunyai",
  "memiliki",
  "melakukan",
  "lakukan",
  "melakukan",
  "sedang",
  "satu",
  "seorang",
  "yang",
  "di dalam",
  "dan",
  "untuk",
  "di",
  "di atas",
  "di bawah",
  "antara",
  "ke dalam",
  "melalui",
  "merentas",
  "selepas",
  "sebelum",
  "semasa",
  "di atas",
  "di bawah",
  "sekitar",
  "sepanjang",
  "seiring",
  "di dalam",
  "tanpa",
  "melawan",
  "di kalangan",
  "melalui",
  "selama",
  "sehingga",
  "sementara",
  "sebagai",
  "hanya",
  "seperti",
  "sedemikian",
  "hanya",
  "semua",
  "mana-mana",
  "kedua-duanya",
  "setiap",
  "sedikit",
  "lebih",
  "paling",
  "beberapa",
  "sama",
  "sama ada",
  "tidak ada",
  "lain",
  "satu",
  "dua",
  "tiga",
  "pertama",
  "kedua",
  "seterusnya",
  "akhir",
  "satu",
  "dua",
  "tiga",
  "empat",
  "lima",
  "enam",
  "tujuh",
  "lapan",
  "sembilan",
  "sepuluh",
  "sebelas",
  "dua belas",
  "tiga belas",
  "empat belas",
  "lima belas",
  "enam belas",
  "tujuh belas",
  "lapan belas",
  "sembilan belas",
  "dua puluh",
  "mana-mana",
  "tidak",
  "ya",
  "tidak",
  "kerana",
  "sejak",
  "sementara",
  "jika",
  "walaupun",
  "meskipun",
  "sama ada",
  "selepas",
  "sebelum",
  "sehingga",
  "melainkan",
  "semasa",
  "di",
  "pada",
  "oleh",
  "ke",
  "dengan",
  "untuk",
  "melawan",
  "tentang",
  "antara",
  "semasa",
  "ke dalam",
  "sekitar",
  "mati",
  "dari",
  "di dalam",
  "ke dalam",
  "sepanjang",
  "di atas",
  "melintasi",
];
